import React, { useCallback } from 'react';
import { Dialog, DialogContent, DialogTitle, Typography, Button, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface SuccessModalProps {
  open: boolean;
  onClose: () => void;
}

const SuccessModal = ({ open, onClose }: SuccessModalProps) => {
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 3,
        },
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', position: 'relative', pb: 0 }}>
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 0,
            color: 'grey.500',
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h5" component="span" fontWeight={700}>
          Solicitação recebida!
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center', pt: 2 }}>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Tudo certo por aqui. Estamos só esperando a aprovação do pagamento para a efetivação do seu pedido.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClose}
            fullWidth
            sx={{
              maxWidth: 400,
              py: 1.5,
              borderRadius: 6,
              borderWidth: 2,
              '&:hover': {
                borderWidth: 2,
              },
            }}
          >
            Ok, aguardar
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;
